import { Attr, HasMany, HasOne, Model } from "spraypaint";

import SourceRecord from "shared/resources/SourceRecord";

import type Category from "./Category";
import type Outlet from "./Outlet";
import type SourceGroup from "./SourceGroup";
import type TvChannelsBroadcastRecorder from "./TvChannelsBroadcastRecorder";

@Model()
class TvChannel extends SourceRecord {
  static jsonapiType = "tv_channels";

  @Attr() aliases: string[];

  @Attr({ persist: false }) archivedAt: string;

  @Attr() audienceDataSupplier: string;

  @Attr() audienceVendorChannel: string;

  @Attr() audienceVendorKey: string;

  @HasOne() category: Category;

  @Attr() categoryId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() epgChannelId: number;

  @Attr() epgRegionId: number;

  @Attr() ffmpegOptions: Record<string, any>;

  @Attr() fromVastSatellite: boolean;

  @Attr() fullName: string;

  @Attr() label: string;

  @Attr() languageCode: string;

  @Attr() locationId: number;

  @Attr() logoData: string;

  @Attr({ persist: false }) medium: string;

  @Attr() newsieUuid: string;

  @Attr() notes: string;

  @Attr() notifyOutageAfterMinutes: number;

  @Attr() notifyOutageViaPagerduty: boolean;

  @HasOne() outlet: Outlet;

  @Attr() outletId: number;

  @Attr() oztamChannel: string;

  @Attr() oztamCity: string;

  @HasOne() sourceGroup: SourceGroup;

  @Attr() sourceGroupId: number;

  @Attr() syndication: string;

  @Attr() tier: number;

  @Attr() transcribePrograms: boolean;

  @Attr() transcriptionEngine: string;

  @HasMany()
  tvChannelsBroadcastRecorders: TvChannelsBroadcastRecorder[];

  @Attr({ persist: false }) updatedAt: string;

  @Attr() url: string;

  @Attr() visible: boolean;

  @Attr() watermarkPreset: string;

  @Attr() watermarkUrl: string;
}

export default TvChannel;
